import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { ScrollView } from 'react-native';
import styled from 'styled-components/native';
import FilterIcon from '@/assets/icon/ic_filter.svg';
import AngleBracketDownIcon from '@/assets/icon/ic_angle_bracket_down.svg';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function FilterBar({ mode, filters, onOpenFilterModal, visibleChips, }) {
    const isMap = mode === 'map';
    const isChipVisible = (chip) => visibleChips == null || visibleChips.includes(chip);
    const isSortActive = filters.sortOption !== null;
    const isSlopeActive = filters.hasSlope !== null;
    const isScoreActive = filters.scoreUnder !== null;
    const isRegisteredActive = filters.isRegistered !== null;
    const sortLabel = filters.sortOption === 'distance'
        ? '가까운순'
        : filters.sortOption === 'accessibility_score'
            ? '접근레벨 낮은순'
            : '정렬';
    return (_jsx(FilterContainer, { "$isMap": isMap, children: _jsxs(ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false, contentContainerStyle: {
                paddingHorizontal: isMap ? 12 : 20,
                gap: 6,
            }, children: [isChipVisible('filter') && (_jsxs(FilterTextChip, { elementName: "filter_chip", activeOpacity: 0.7, "$isMap": isMap, onPress: () => onOpenFilterModal('All'), children: [_jsx(FilterIcon, { width: 16, height: 16, color: "#24262B" }), _jsx(FilterChipText, { "$isMap": isMap, children: "\uD544\uD130" })] })), isChipVisible('sort') && (_jsxs(DropdownChip, { elementName: "filter_sort", activeOpacity: 0.7, "$isMap": isMap, "$active": isSortActive, onPress: () => onOpenFilterModal('sortOption'), children: [_jsx(ChipText, { "$isMap": isMap, "$active": isSortActive, children: sortLabel }), _jsx(AngleBracketDownIcon, { width: 16, height: 16, color: isSortActive ? color.brandColor : isMap ? '#24262B' : '#16181C' })] })), isChipVisible('slope') && (_jsx(PlainChip, { elementName: "filter_slope", activeOpacity: 0.7, "$isMap": isMap, "$active": isSlopeActive, onPress: () => onOpenFilterModal('hasSlope'), children: _jsx(ChipText, { "$isMap": isMap, "$active": isSlopeActive, children: filters.hasSlope === true
                            ? '경사로 있음'
                            : filters.hasSlope === false
                                ? '경사로 없음'
                                : '경사로 유무' }) })), isChipVisible('score') && (_jsx(PlainChip, { elementName: "filter_access_level", activeOpacity: 0.7, "$isMap": isMap, "$active": isScoreActive, onPress: () => onOpenFilterModal('scoreUnder'), children: _jsx(ChipText, { "$isMap": isMap, "$active": isScoreActive, children: filters.scoreUnder !== null
                            ? `Lv.${filters.scoreUnder} 이하`
                            : '접근레벨' }) })), isChipVisible('conquered') && (_jsx(PlainChip, { elementName: "filter_conquered", activeOpacity: 0.7, "$isMap": isMap, "$active": isRegisteredActive, onPress: () => onOpenFilterModal('isRegistered'), children: _jsx(ChipText, { "$isMap": isMap, "$active": isRegisteredActive, children: filters.isRegistered === true
                            ? '정복완료'
                            : filters.isRegistered === false
                                ? '미정복'
                                : '정복여부' }) }))] }) }));
}
const FilterContainer = styled.View `
  background-color: ${({ $isMap }) => ($isMap ? color.white : color.gray5)};
  padding-top: ${({ $isMap }) => ($isMap ? '4px' : '10px')};
  padding-bottom: 10px;
`;
const chipBase = `
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 56px;
  border-width: 1px;
`;
const FilterTextChip = styled(SccTouchableOpacity) `
  ${chipBase}
  height: 36px;
  padding-horizontal: 12px;
  gap: 2px;
  background-color: white;
  border-color: #eaeaef;
`;
const FilterChipText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.28px;
  color: ${({ $isMap }) => ($isMap ? '#24262b' : '#16181c')};
`;
const DropdownChip = styled(SccTouchableOpacity) `
  ${chipBase}
  height: 36px;
  padding-horizontal: 12px;
  padding-vertical: 8px;
  min-width: 56px;
  gap: 2px;
  background-color: ${({ $active }) => ($active ? '#EBF3FE' : 'white')};
  border-color: ${({ $active }) => ($active ? color.brandColor : '#EAEAEF')};
`;
const PlainChip = styled(SccTouchableOpacity) `
  ${chipBase}
  height: 36px;
  padding-horizontal: 12px;
  padding-vertical: 8px;
  min-width: 56px;
  background-color: ${({ $active }) => ($active ? '#EBF3FE' : 'white')};
  border-color: ${({ $active }) => ($active ? color.brandColor : '#EAEAEF')};
`;
const ChipText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.28px;
  color: ${({ $active, $isMap }) => $active ? color.brandColor : $isMap ? '#24262b' : '#16181c'};
  include-font-padding: false;
  text-align-vertical: center;
`;
